import React from 'react';
import { connect } from 'react-redux';
import { translate } from 'react-i18next';

import Render from '../common/Render';
import List from './List';
import { requestDataIfNeeded } from './duck';

class Screen extends React.Component {
  componentDidMount() {
    this.props.requestDataIfNeeded();
  }

  renderAfterLoading = () => {
    const { newsletters } = this.props;

    return <List newsletters={newsletters} />;
  };

  render() {
    const { isLoading, error } = this.props;

    return (
      <Render
        isLoading={isLoading}
        error={error}
        render={this.renderAfterLoading}
      />
    );
  }
}

const mapDispatchToProps = { requestDataIfNeeded };

const mapStateToProps = ({ newsletters }) => ({
  error: newsletters.error,
  isLoading: newsletters.isLoading,
  newsletters: newsletters.data,
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(translate()(Screen));



// WEBPACK FOOTER //
// ./src/newsletters/Screen.js